/* tslint:disable */
/* eslint-disable */
/**
 * Bonds API
 * Microservice backend for bond management
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(timezone);
/**
 * 
 * @export
 * @interface Company
 */
export interface Company {
    /**
     * 
     * @type {number}
     * @memberof Company
     */
    readonly id: number;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    readonly residenceAddress: string;
    /**
     * 
     * @type {number}
     * @memberof Company
     */
    readonly issueCount: number;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    readonly logo: string;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    readonly signature: string;
    /**
     * 
     * @type {boolean}
     * @memberof Company
     */
    readonly fioKeyLinked: boolean;
    /**
     * 
     * @type {Date}
     * @memberof Company
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof Company
     */
    readonly updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    companyId: string;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    executiveName?: string;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    executiveRole?: string;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    bankAccountNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    mailAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    web?: string;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    documentBorderColor?: string;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    signaturePlace?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof Company
     */
    aresData?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    returnCollectionText?: string;
}

/**
 * Check if a given object implements the Company interface.
 */
export function instanceOfCompany(value: object): boolean {
    if (!('id' in value)) return false;
    if (!('residenceAddress' in value)) return false;
    if (!('issueCount' in value)) return false;
    if (!('logo' in value)) return false;
    if (!('signature' in value)) return false;
    if (!('fioKeyLinked' in value)) return false;
    if (!('createdAt' in value)) return false;
    if (!('updatedAt' in value)) return false;
    if (!('name' in value)) return false;
    if (!('companyId' in value)) return false;
    return true;
}

export function CompanyFromJSON(json: any): Company {
    return CompanyFromJSONTyped(json, false);
}

export function CompanyFromJSONTyped(json: any, ignoreDiscriminator: boolean): Company {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'residenceAddress': json['residence_address'],
        'issueCount': json['issue_count'],
        'logo': json['logo'],
        'signature': json['signature'],
        'fioKeyLinked': json['fio_key_linked'],
        'createdAt': (dayjs(json['created_at']).toDate()),
        'updatedAt': (dayjs(json['updated_at']).toDate()),
        'name': json['name'],
        'companyId': json['company_id'],
        'executiveName': json['executive_name'] == null ? undefined : json['executive_name'],
        'executiveRole': json['executive_role'] == null ? undefined : json['executive_role'],
        'bankAccountNumber': json['bank_account_number'] == null ? undefined : json['bank_account_number'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'email': json['email'] == null ? undefined : json['email'],
        'mailAddress': json['mail_address'] == null ? undefined : json['mail_address'],
        'web': json['web'] == null ? undefined : json['web'],
        'slug': json['slug'] == null ? undefined : json['slug'],
        'documentBorderColor': json['document_border_color'] == null ? undefined : json['document_border_color'],
        'signaturePlace': json['signature_place'] == null ? undefined : json['signature_place'],
        'aresData': json['ares_data'] == null ? undefined : json['ares_data'],
        'returnCollectionText': json['return_collection_text'] == null ? undefined : json['return_collection_text'],
    };
}

export function CompanyToJSON(value?: Company | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'company_id': value['companyId'],
        'executive_name': value['executiveName'],
        'executive_role': value['executiveRole'],
        'bank_account_number': value['bankAccountNumber'],
        'phone': value['phone'],
        'email': value['email'],
        'mail_address': value['mailAddress'],
        'web': value['web'],
        'slug': value['slug'],
        'document_border_color': value['documentBorderColor'],
        'signature_place': value['signaturePlace'],
        'ares_data': value['aresData'],
        'return_collection_text': value['returnCollectionText'],
    };
}

